import {
  Integration,
  CreateIntegrationDto,
  UpdateIntegrationDto,
  FindIntegrationsDto,
  IntegrationStats,
  PaginatedResponse,
  TestConnectionResponse,
  IntegrationMetadata,
  IntegrationUserConfig,
} from '../types/integration.types';
import { adminApi } from '@/config/axios.config';

export const integrationsApiService = {
  // Obtener todas las integraciones
  getIntegrations: async (
    query: FindIntegrationsDto = {},
  ): Promise<PaginatedResponse<Integration>> => {
    const response = await adminApi.get('/integrations', { params: query });
    return response.data;
  },

  // Obtener una integraciИn por ID
  getIntegration: async (id: string): Promise<Integration> => {
    const response = await adminApi.get(`/integrations/${id}`);
    return response.data;
  },

  // Crear una nueva integraciИn
  createIntegration: async (data: CreateIntegrationDto): Promise<Integration> => {
    const response = await adminApi.post('/integrations', data);
    return response.data;
  },

  // Actualizar una integraciИn
  updateIntegration: async (
    id: string,
    data: UpdateIntegrationDto,
  ): Promise<Integration> => {
    const response = await adminApi.put(`/integrations/${id}`, data);
    return response.data;
  },

  // Eliminar una integraciИn
  deleteIntegration: async (id: string): Promise<void> => {
    await adminApi.delete(`/integrations/${id}`);
  },

  // Cambiar estado de una integraciИn
  toggleIntegrationStatus: async (id: string): Promise<Integration> => {
    const response = await adminApi.put(`/integrations/${id}/status`);
    return response.data;
  },

  // Probar conexiИn de una integraciИn
  testConnection: async (id: string): Promise<TestConnectionResponse> => {
    const response = await adminApi.post(`/integrations/${id}/test`);
    return response.data;
  },

  // Obtener estadВстicas de integraciones
  getStats: async (): Promise<IntegrationStats> => {
    const response = await adminApi.get('/integrations/stats');
    return response.data;
  },

  // Obtener providers disponibles
  getAvailableProviders: async (filters?: {
    category?: string;
    type?: string;
    module?: string;
    capability?: string;
  }): Promise<IntegrationMetadata[]> => {
    const response = await adminApi.get('/integrations/available/providers', {
      params: filters,
    });
    return response.data;
  },

  // Obtener estadВстicas del registry
  getRegistryStats: async (): Promise<{
    total: number;
    byCategory: Record<string, number>;
    byType: Record<string, number>;
    byModule: Record<string, number>;
  }> => {
    const response = await adminApi.get('/integrations/registry/stats');
    return response.data;
  },

  // Configuraciones por usuario
  getUserConfigs: async (integrationId: string): Promise<IntegrationUserConfig[]> => {
    const response = await adminApi.get(`/integrations/${integrationId}/user-configs`);
    return response.data;
  },

  getUserConfig: async (
    integrationId: string,
    userId: string,
  ): Promise<IntegrationUserConfig> => {
    const response = await adminApi.get(
      `/integrations/${integrationId}/user-configs/${userId}`,
    );
    return response.data;
  },

  upsertUserConfig: async (
    integrationId: string,
    userId: string,
    data: { config: Record<string, any>; isDefault?: boolean },
  ): Promise<IntegrationUserConfig> => {
    const response = await adminApi.put(
      `/integrations/${integrationId}/user-configs/${userId}`,
      data,
    );
    return response.data;
  },

  deleteUserConfig: async (integrationId: string, userId: string): Promise<void> => {
    await adminApi.delete(`/integrations/${integrationId}/user-configs/${userId}`);
  },
};

// Alias para compatibilidad
export const integrationsApi = {
  integrations: integrationsApiService,
};
